/**
 * Code by Mathieu VANBESELAERE for ->
 * @copyright Copyright (c) Agence ink
 */

//// Module summary ////
// Replace user's cursor, animate it while hovering a link

/////////////// GSAP animation modules (Uncomment required gsap library!) /////////////////
import gsap from "gsap";
// import ScrollTrigger from "gsap/ScrollTrigger"; gsap.registerPlugin(ScrollTrigger);
// import ScrollSmoother from "gsap/ScrollSmoother"; gsap.registerPlugin(ScrollSmoother);
// import ScrollToPlugin from "gsap/ScrollToPlugin"; gsap.registerPlugin(ScrollToPlugin);
// import DrawSVGPlugin from "gsap/DrawSVGPlugin"; gsap.registerPlugin(DrawSVGPlugin);
// import MorphSVG from "gsap/MorphSVGPlugin"; gsap.registerPlugin(MorphSVG);
// import SplitText from "gsap/SplitText"; gsap.registerPlugin(SplitText);
///////////////////////////////////////////////////////////////////////////////////////////

export const cursor = () => {
    let cursor = document.querySelector('.cursor-2');
    if (cursor) {
        const CURSOR_TL = gsap.timeline({
            paused: true
        });
        CURSOR_TL.to(cursor, {
            background: "white",
            width: "60px",
            height: "60px",
            borderColor: "transparent",
            duration: .2
        });

        let links = document.querySelectorAll('a, input, button');
        for (let currentLink of links) {
            currentLink.addEventListener('mouseenter', () => { 
                CURSOR_TL.play();
            });
            currentLink.addEventListener('mouseleave', () => { 
                CURSOR_TL.reverse();
            });
        }
    }
    return;
};
